<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import ShiftWizard from '../../../shift_wizard/components/ShiftWizard.vue'

definePage({
    meta: {
        requiresAuth: true,
        requiresOrganisation: true,
        hideLeftColumn: true,
        hideRightColumn: true,
        childNavItems: [
            {
                label: 'Shifts',
                route: '/(app)/schedule/shifts/',
            },
            {
                label: 'New Shift',
                route: '/(app)/schedule/shifts.wizard',
            },
            {
                label: 'Activity',
                route: '/(app)/schedule/activity/',
            },
            {
                label: 'Calendar',
                route: '/(app)/schedule/calendar/',
            }
        ],
    }
})
</script>

<template>
  <ShiftWizard />
</template>